<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M11.485 13.8065C11.6571 13.8855 11.851 13.9036 12.0347 13.8577C12.2184 13.8118 12.3811 13.7046 12.4958 13.554L12.7916 13.1665C12.9469 12.9595 13.1482 12.7915 13.3796 12.6758C13.611 12.56 13.8662 12.4998 14.125 12.4998H16.6249C17.067 12.4998 17.4909 12.6754 17.8035 12.988C18.116 13.3005 18.2916 13.7244 18.2916 14.1665V16.6665C18.2916 17.1085 18.116 17.5324 17.8035 17.845C17.4909 18.1575 17.067 18.3331 16.6249 18.3331C12.6467 18.3331 8.83142 16.7528 6.01838 13.9397C3.20535 11.1267 1.625 7.3114 1.625 3.33316C1.625 2.89114 1.80059 2.46722 2.11315 2.15466C2.42571 1.8421 2.84964 1.6665 3.29166 1.6665H5.79165C6.23368 1.6665 6.6576 1.8421 6.97016 2.15466C7.28272 2.46722 7.45831 2.89114 7.45831 3.33316V5.83316C7.45831 6.0919 7.39807 6.34709 7.28236 6.57851C7.16665 6.80993 6.99864 7.01124 6.79165 7.16649L6.40165 7.45898C6.24866 7.5758 6.14083 7.74197 6.09648 7.92927C6.05212 8.11658 6.07397 8.31346 6.15832 8.48648C7.29721 10.7997 9.17033 12.6705 11.485 13.8065Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconPhone',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
